import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import React from 'react';
import { useEffect, useState} from 'react';
import axios from 'axios';
import 'primeflex/primeflex.css';
import MenubarView from './MenubarView';
import { Dropdown } from 'primereact/dropdown';


const CashFlowView = () => {
    //const serviceuriroot = ((process.env.REACT_APP_serviceuriroot === undefined) ? 'http://localhost:8080': process.env.REACT_APP_serviceuriroot);
    const [entries, setEntries] = useState(null);
    const [co, setCo] = useState(0.00);
    const [years,setYears] = useState([]);
    const [selectedYear,setSelectedYear] = useState(null);
   
    

    useEffect(() => {
        let dt = new Date()
        let currentYear = dt.getFullYear()
        setSelectedYear(currentYear)
        let yrs = []
        for (let i = 0; i < (currentYear-2013); i++) yrs.push(currentYear-i)
            setYears(yrs)
        convertToMatrix(currentYear)
    },[]) // eslint-disable-line react-hooks/exhaustive-deps


   async function convertToMatrix (yr) { 
        var dt = new Date();
        var currentYear = dt.getFullYear();
        var year = null;
        if (yr==null) {
            setSelectedYear(currentYear);
            year = currentYear;
        } else {
            year = yr;
        } 
        let filter = '(' + localStorage.getItem('dataAccess').toString() + ')'
        var matrix = []
        var colTotals= ['TOTALS',0,0,0,0,0,0,0,0,0,0,0,0,0]
        var runTotals= ['RUNNING TOTALS',0,0,0,0,0,0,0,0,0,0,0,0,0]
        let carryOver = 0.00
        let fEntries = null;
        const token = localStorage.getItem('bearerToken')
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };
        const url = '/v1/reports/sumbymonthbyyearbycategory/where cashentry.ownerid in ' + filter;
        await axios.get(url,config)
        .then(response => response.data)
        .then(response => {
            fEntries=response;
        })
            
        fEntries.forEach(item => {
            if (year===(item.year)) {
                let i = -1
                if (matrix.length) {
                    matrix.forEach((row, index) => {
                        if (row.includes(item.category)) {
                            i=index
                        }
                    });
                }
                if (i<0) {
                    matrix.push([item.category,0,0,0,0,0,0,0,0,0,0,0,0,0]) 
                    i = matrix.length -1 
                }
                switch (item.month) {
                    case 'January':
                    matrix[i][1]=item.amount
                    colTotals[1] = colTotals[1] + parseFloat(item.amount)
                    break;
                    case 'February':
                        matrix[i][2]=item.amount
                        colTotals[2] = colTotals[2] + parseFloat(item.amount)
                        break;
                    case 'March':
                        matrix[i][3]=item.amount
                        colTotals[3] = colTotals[3] + parseFloat(item.amount)
                        break;
                    case 'April':
                        matrix[i][4]=item.amount
                        colTotals[4] = colTotals[4] + parseFloat(item.amount)
                        break;
                    case 'May':
                        matrix[i][5]=item.amount
                        colTotals[5] = colTotals[5] + parseFloat(item.amount)
                        break;
                    case 'June':
                        matrix[i][6]=item.amount
                        colTotals[6] = colTotals[6] + parseFloat(item.amount)
                        break;
                    case 'July':
                        matrix[i][7]=item.amount
                        colTotals[7] = colTotals[7] + parseFloat(item.amount)
                        break;
                    case 'August':
                        matrix[i][8]=item.amount
                        colTotals[8] = colTotals[8] + parseFloat(item.amount)
                        break;
                    case 'September':
                        matrix[i][9]=item.amount
                        colTotals[9] = colTotals[9] + parseFloat(item.amount)
                        break;
                    case 'October':
                        matrix[i][10]=item.amount
                        colTotals[10] = colTotals[10] + parseFloat(item.amount)
                        break;
                    case 'November':
                        matrix[i][11]=item.amount
                        colTotals[11] = colTotals[11] + parseFloat(item.amount)
                        break;
                    case 'December':
                        matrix[i][12]=item.amount
                        colTotals[12] = colTotals[12] + parseFloat(item.amount)
                        break;
                    default:
                }
            } else if(year > item.year) {
                carryOver += item.amount
            }
        
        })
        
        let rt = carryOver
        for (var j=1;j<colTotals.length;j++){
            rt += colTotals[j]
            runTotals[j] = rt
        }
        colTotals[13] = rt - carryOver
        for (j=0;j<matrix.length;j++)
            for (var k=1;k<13;k++) 
                matrix[j][13]+=matrix[j][k]
        
        matrix.push(colTotals)
        matrix.push(runTotals)
        setEntries(matrix)
        setCo(carryOver)
        
    }

    
   
    const onYearSelectionChange = (e) => {
        setSelectedYear(e.value)
        convertToMatrix(e.value)
    }

    const formatOutput = (value) => {
        if (value) 
            return (new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2
            }).format(value))
        else
            return ('')
    }
    
    const mystyle = {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingTop: '100px',
        width: '50%',
        height: '50%'
    }
        
    if (entries === null) {
        return (
            <img alt='loading' style={mystyle} src='./logo.gif'/>
        )
    }
    else {
        return (
            
            <div> 
            <div><MenubarView/></div>
            {entries && (
            <div style={{margin:"5px"}}>
              
                <table>
                <thead>
                        <tr>
                            <td> <Dropdown
                                id = "yearSelector"
                                value={selectedYear}
                                options={years}
                                onChange={onYearSelectionChange}
                            /></td>
                            <td style={{color:'lightSteelBlue',backgroundColor:'whiteSmoke',fontWeight: 'bold', textAlign: "center"}}>
                                JANUARY
                            </td>
                            <td style={{color:'lightSteelBlue',backgroundColor:'whiteSmoke',fontWeight: 'bold', textAlign: "center"}}>
                                FEBRUARY
                            </td>
                            <td style={{color:'lightSteelBlue',backgroundColor:'whiteSmoke',fontWeight: 'bold', textAlign: "center"}}>
                                MARCH
                            </td>
                            <td style={{color:'lightSteelBlue',backgroundColor:'whiteSmoke',fontWeight: 'bold', textAlign: "center"}}>
                                APRIL
                            </td>
                            <td style={{color:'lightSteelBlue',backgroundColor:'whiteSmoke',fontWeight: 'bold', textAlign: "center"}}>
                                MAY
                            </td>
                            <td style={{color:'lightSteelBlue',backgroundColor:'whiteSmoke',fontWeight: 'bold', textAlign: "center"}}>
                                JUNE
                            </td>
                            <td style={{color:'lightSteelBlue',backgroundColor:'whiteSmoke',fontWeight: 'bold', textAlign: "center"}}>
                                JULY
                            </td>
                            <td style={{color:'lightSteelBlue',backgroundColor:'whiteSmoke',fontWeight: 'bold', textAlign: "center"}}>
                                AUGUST
                            </td>
                            <td style={{color:'lightSteelBlue',backgroundColor:'whiteSmoke',fontWeight: 'bold', textAlign: "center"}}>
                                SEPTEMBER
                            </td>
                            <td style={{color:'lightSteelBlue',backgroundColor:'whiteSmoke',fontWeight: 'bold', textAlign: "center"}}>
                                OCTOBER
                            </td>
                            <td style={{color:'lightSteelBlue',backgroundColor:'whiteSmoke',fontWeight: 'bold', textAlign: "center"}}>
                                NOVEMBER
                            </td>
                            <td style={{color:'lightSteelBlue',backgroundColor:'whiteSmoke',fontWeight: 'bold', textAlign: "center"}}>
                                DECEMBER
                            </td>
                            <td style={{color:'steelBlue',backgroundColor:'whiteSmoke',fontWeight: 'bold', textAlign: "center"}}>
                                TOTALS
                            </td>
                        </tr>
                    </thead>
                    <tbody>
        
                    {entries.map((item, index) => (
                    <tr>
                        <td style={index>=(entries.length-2)?{color:'steelBlue',backgroundColor:'whiteSmoke',fontWeight: 'bold'}:{color:'lightSteelBlue',backgroundColor:'whiteSmoke',fontWeight: 'bold'}}>{item[0].toUpperCase()}</td>
                        <td style={item[1]>=0?{fontWeight:'bold',color:'darkSeaGreen'}:{fontWeight:'bold',color:'lightCoral'}}>{formatOutput(item[1])}</td>
                        <td style={item[2]>=0?{fontWeight:'bold',color:'darkSeaGreen'}:{fontWeight:'bold',color:'lightCoral'}}>{formatOutput(item[2])}</td>
                        <td style={item[3]>=0?{fontWeight:'bold',color:'darkSeaGreen'}:{fontWeight:'bold',color:'lightCoral'}}>{formatOutput(item[3])}</td>
                        <td style={item[4]>=0?{fontWeight:'bold',color:'darkSeaGreen'}:{fontWeight:'bold',color:'lightCoral'}}>{formatOutput(item[4])}</td>
                        <td style={item[5]>=0?{fontWeight:'bold',color:'darkSeaGreen'}:{fontWeight:'bold',color:'lightCoral'}}>{formatOutput(item[5])}</td>
                        <td style={item[6]>=0?{fontWeight:'bold',color:'darkSeaGreen'}:{fontWeight:'bold',color:'lightCoral'}}>{formatOutput(item[6])}</td>
                        <td style={item[7]>=0?{fontWeight:'bold',color:'darkSeaGreen'}:{fontWeight:'bold',color:'lightCoral'}}>{formatOutput(item[7])}</td>
                        <td style={item[8]>=0?{fontWeight:'bold',color:'darkSeaGreen'}:{fontWeight:'bold',color:'lightCoral'}}>{formatOutput(item[8])}</td>
                        <td style={item[9]>=0?{fontWeight:'bold',color:'darkSeaGreen'}:{fontWeight:'bold',color:'lightCoral'}}>{formatOutput(item[9])}</td>
                        <td style={item[10]>=0?{fontWeight:'bold',color:'darkSeaGreen'}:{fontWeight:'bold',color:'lightCoral'}}>{formatOutput(item[10])}</td>
                        <td style={item[11]>=0?{fontWeight:'bold',color:'darkSeaGreen'}:{fontWeight:'bold',color:'lightCoral'}}>{formatOutput(item[11])}</td>
                        <td style={item[12]>=0?{fontWeight:'bold',color:'darkSeaGreen'}:{fontWeight:'bold',color:'lightCoral'}}>{formatOutput(item[12])}</td>
                        <td style={item[13]>=0?{fontWeight:'bold',backgroundColor:'whiteSmoke',color:'darkSeaGreen'}:{fontWeight:'bold',backgroundColor:'whiteSmoke',color:'lightCoral'}}>{formatOutput(item[13])}</td>
                    </tr>
                    ))}
                <tr >
                    <td style={{color:'steelBlue',backgroundColor:'whiteSmoke',fontWeight: 'bold', textAlign: "left"}}>CARRY OVER</td><td style={co>=0?{fontWeight:'bold',backgroundColor:'whiteSmoke',color:'darkSeaGreen'}:{fontWeight:'bold',backgroundColor:'whiteSmoke',color:'lightCoral'}}>{formatOutput(co)}</td>
                    <td></td><td></td><td></td><td></td><td></td>
                    <td></td><td></td><td></td><td></td><td></td>
                    <td></td><td></td>
                </tr>
                </tbody></table>
                
            </div>
            )}
            </div>
        )
    }
}

export default CashFlowView;